module.exports = __webpack_public_path__ + "img/img_select_dao.0ab65233.png";